// Client filter schema — type-driven, mirrors server/filters.js CLIENT_REGISTRY.

const CLIENT_STATUS_OPTIONS = [
  { value: 'prospect', label: 'Prospect' },
  { value: 'active', label: 'Active' },
  { value: 'dormant', label: 'Dormant' },
  { value: 'archived', label: 'Archived' },
];

export const CLIENT_SCHEMA = {
  groups: ['Client', 'Firmographics', 'Funding and growth', 'What they do', 'Relationship', 'Dates'], // C1-CLIENTFACTS
  fields: [
    { key: 'name', label: 'Name', group: 'Client', type: 'text' },
    { key: 'status', label: 'Status', group: 'Client', type: 'enum', options: CLIENT_STATUS_OPTIONS },
    { key: 'sector', label: 'Sector', group: 'Firmographics', type: 'text', dropdown: 'sector' },
    { key: 'size', label: 'Size', group: 'Firmographics', type: 'text' },
    { key: 'location', label: 'Location', group: 'Firmographics', type: 'text', dropdown: 'location' },
    { key: 'has_website', label: 'Has website', group: 'Firmographics', type: 'boolean' },
    { key: 'latest_funding', label: 'Latest funding round', group: 'Funding and growth', type: 'text', dropdown: 'latest_funding' },
    { key: 'last_raised_at', label: 'Last raised', group: 'Funding and growth', type: 'date' },
    { key: 'latest_funding_amount', label: 'Latest round amount (millions)', group: 'Funding and growth', type: 'number' },
    { key: 'total_funding', label: 'Total funding (millions)', group: 'Funding and growth', type: 'number' },
    { key: 'employees', label: 'Employees', group: 'Funding and growth', type: 'number' },
    { key: 'annual_revenue', label: 'Annual revenue (millions)', group: 'Funding and growth', type: 'number' },
    { key: 'founded_year', label: 'Founded (year)', group: 'Funding and growth', type: 'number' },
    { key: 'technologies', label: 'Technologies', group: 'What they do', type: 'text' },
    { key: 'keywords', label: 'Keywords', group: 'What they do', type: 'text' },
    { key: 'description', label: 'Description', group: 'What they do', type: 'text' },
    { key: 'has_company_data', label: 'Has company data', group: 'What they do', type: 'exists' },
    { key: 'has_roles', label: 'Has roles', group: 'Relationship', type: 'exists' },
    { key: 'has_contacts', label: 'Has contacts', group: 'Relationship', type: 'exists' },
    { key: 'has_brief', label: 'Has brief', group: 'Relationship', type: 'boolean' },
    { key: 'created_at', label: 'Added date', group: 'Dates', type: 'date' },
    { key: 'updated_at', label: 'Modified date', group: 'Dates', type: 'date' },
  ],
  quick: ['status', 'has_roles', 'sector', 'latest_funding', 'last_raised_at'],
};

export const DATE_PRESETS = [
  { value: 7, label: 'Last 7 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 90, label: 'Last 90 days' },
];

const _schema = { CLIENT_SCHEMA, DATE_PRESETS };
export default _schema;
